class AppointmentOutcomeTool {
  constructor(container, status) {
    this.status = status;
    this.$container = jQuery(container);

    this.$acceptedSection = this.$container.find("#apt-accepted-section");
    this.$cancelledSection = this.$container.find("#apt-canceled-section");
    this.$scheduledSection = this.$container.find("#apt-scheduled-section");
    this.$outcomeSection = this.$container.find("#apt-outcome-section");
    this.$statusInput = this.$container.find("#patient_journey_task_tool_payload_appointment_status");
    this.$outcomeDropdown = this.$outcomeSection.find(
      "#patient_journey_task_tool_payload_appointment_appointment_outcome_id",
    );

    this.init();
  }

  resetForm() {
    this.$acceptedSection.hide();
    this.$cancelledSection.hide();
    this.$scheduledSection.hide();
    this.$outcomeSection.hide();
  }

  showScheduled() {
    this.resetForm();
    this.$scheduledSection.show();
  }

  showAccepted() {
    this.resetForm();
    this.$acceptedSection.show();
    this.$outcomeSection.show();
  }

  showCancelled() {
    this.resetForm();
    this.$cancelledSection.show();
  }

  init() {
    this.resetForm();

    if (this.status == "scheduled") {
      this.showScheduled();

      this.$scheduledSection.on("click", () => {
        this.showAccepted();
        this.$statusInput.val("accepted");
      });
    } else {
      this.showAccepted();

      this.$outcomeDropdown.on("change", () => {
        this.$statusInput.val("completed");
      });
    }
  }
}

window.AppointmentOutcomeTool = AppointmentOutcomeTool;
